import Model from './Model'
export default class CustomerFeedback extends Model {

    resource()
    {
        return 'feedbacks'
    }
}
